module.exports = __webpack_public_path__ + "static/media/20180529_184042.ed9be433.jpg";